import { RecipeCategory } from '../models/recipe'
import { API_PREFIX } from './constant'
import { Request } from './request'


export function getMaterialCompletions(
  params: { keyword: string; current: number; size?: number },
  recipeCategory?: RecipeCategory,
  includeAllTcm?: boolean,
  insuranceCode?: string,
  isFullMatch?: any,
  isWubi?: any,
  isRestrictUser?: any,
  storehouseCategory?: any,
  normalGysName?:any,
  phone?: string,
  isMember?: any, //是否会员开方
  approvalNumber?: any,
  transitionScale?: any,
  receiptsType?: number,
  tenantMaterialsCatalogId?: string | number,
): Request {
  let flag = 0
  switch (recipeCategory) {
    case RecipeCategory.Dispose:
      flag = 5
      break
    case RecipeCategory.Medicine:
    case RecipeCategory.ShuZhuFang:
      flag = 1
      break
    case RecipeCategory.TcmGranules:
      flag = includeAllTcm ? 4 : 2
      break
    case RecipeCategory.TcmApply:
    case RecipeCategory.Tcm:
      flag = includeAllTcm ? 4 : 3
      break
  }

  return {
    url: `${API_PREFIX}/blade-store/materialscatalog/page`,
    method: 'GET',
    params: {
      allStr: params.keyword,
      materialsCategory: -1, // materialscategory 供货物资类别:0药品:1材料:2器械:3保健品:4非药品
      allMaterials: -1, //allMaterials ==  0兴奋剂标记 1麻黄碱标识 2抗生素标识 3基药标记
      tenantSupplierId: -1,//供应商id
      state: 1, //租户物资状态:0注销:1启用
      otc: -1,
      current: params.current,
      size: params.size || 5,
      flag:
        storehouseCategory == 2
          ? 4
          : storehouseCategory == 1
          ? 1
          : recipeCategory === undefined
          ? undefined
          : flag,
      insuranceCode,
      approveFlg: insuranceCode && insuranceCode != 'ZIFEI' ? null : 1,// 审批标志,写死查询审批已通过
      isFullMatch: isFullMatch?.toString() ? 0 : undefined, //是否完全匹配   
      isWubi: isWubi || '0',
      isRestrictUser: isRestrictUser ? isRestrictUser : null, //isRestrictUser=1 时 匹配允许开单医生
      normalGysName:normalGysName ? normalGysName :null, //常用供应商
      phone: phone ? phone : undefined,
      isMember: isMember, //是否会员开方
      approvalNumber: approvalNumber ? approvalNumber : undefined,
      transitionScale: transitionScale ? transitionScale : undefined,
      receiptsType: receiptsType === 1 ? 1 : undefined,
      tenantMaterialsCatalogId: tenantMaterialsCatalogId || undefined,
    },
  }
}

export function getInventoryCompletions(
  params: {
    keyword: string
    current: number
    size?: number
    storehouseId?: string
    merge?: boolean
    serviceShopPrice?: string
    isAllInventory?: boolean
    isFullMatch?: any
    deadlineFlag?: any
    isWubi?: any
    isRestrictUser?: any
    normalGysName?:any
    phone?: string,
    isMember?: any, //是否会员开方
  },
  recipeCategory?: RecipeCategory,
  includeAllTcm?: boolean,
  insuranceCode?: string
): Request {
  let flag = 0
  switch (recipeCategory) {
    case RecipeCategory.Dispose:
      flag = 5
      break
    case RecipeCategory.Medicine:
    case RecipeCategory.ShuZhuFang:
      flag = 1
      break
    case RecipeCategory.TcmGranules:
      flag = includeAllTcm ? 4 : 2
      break
    case RecipeCategory.TcmApply:
    case RecipeCategory.Tcm:
      flag = includeAllTcm ? 4 : 3
      break
  }
  return {
    url: `${API_PREFIX}/blade-store/inventoryledger/page`,
    method: 'GET',
    params: {
      name: params.keyword,
      current: params.current,
      size: params.size || 5,
      state: 1, //租户物资状态:0注销:1启用
      flag,
      storehouseId: params.storehouseId,
      mergeFlag: params.merge ? 1 : 0,
      serviceShopPrice: params.isAllInventory ? null : 1,// 售药权限:0无权限:1有权限
      insuranceCode,
      approveFlg: insuranceCode && insuranceCode != 'ZIFEI' ? null : 1,// 审批标志,写死查询审批已通过
      isFullMatch: params?.isFullMatch?.toString() ? 0 : undefined, //是否完全匹配    
      deadlineFlag: params?.deadlineFlag ? params?.deadlineFlag : undefined,
      isWubi: params?.isWubi || '0',
      isRestrictUser: params?.isRestrictUser ? params?.isRestrictUser : null, //isRestrictUser=1 时 匹配允许开单医生
      normalGysName: params?.normalGysName ? params?.normalGysName : null, //常用供应商
      phone: params?.phone ? params?.phone : undefined,
      isMember: params?.isMember, //是否会员开方
    },
  }
}
export interface batchCailiaoParams {
  keyword: string
  current: number
  size: number
  storehouseId?: string
  merge?: boolean
  serviceShopPrice?: string
  insuranceCode?: string
  isFullMatch?: any
  deadlineFlag?: any
  isRestrictUser?: any
}
export function batchCailiao(params: batchCailiaoParams): Request {
  return {
    url: `${API_PREFIX}/blade-store/inventoryledger/page`,
    method: 'GET',
    params: {
      name: params.keyword,
      current: params.current,
      size: params.size,
      state: 1, //租户物资状态:0注销:1启用
      flag: 5,
      mergeFlag: params.merge ? 1 : 0,
      serviceShopPrice: 1,// 售药权限:0无权限:1有权限
      insuranceCode: params.insuranceCode,
      approveFlg:
        params.insuranceCode && params.insuranceCode != 'ZIFEI' ? null : 1, // 审批标志,写死查询审批已通过
      deadlineFlag: params.deadlineFlag ? params.deadlineFlag : undefined,
      isRestrictUser: params?.isRestrictUser ? params?.isRestrictUser : null, //isRestrictUser=1 时 匹配允许开单医生
    },
  }
}

export interface batchtaocanParams {
  keyword: string
  current: number
  size: number
  storehouseId?: string
  merge?: boolean
  serviceShopPrice?: string
  insuranceCode?: string
  isFullMatch?: any
  deadlineFlag?: any
  isRestrictUser?: any
  flag?: any
}
export function batchTaocan(params: batchtaocanParams): Request {
  return {
    url: `${API_PREFIX}/blade-store/inventoryledger/page`,
    method: 'GET',
    params: {
      name: params.keyword,
      current: params.current,
      size: params.size,
      state: 1, //租户物资状态:0注销:1启用
      flag: params?.flag ? params?.flag : '',
      mergeFlag: params.merge ? 1 : 0,
      serviceShopPrice: 1,// 售药权限:0无权限:1有权限
      insuranceCode: params.insuranceCode,
      approveFlg:
        params.insuranceCode && params.insuranceCode != 'ZIFEI' ? null : 1,// 审批标志,写死查询审批已通过
      isFullMatch: params?.isFullMatch?.toString() ? 0 : undefined,//是否完全匹配   
      deadlineFlag: params.deadlineFlag ? params.deadlineFlag : undefined,
      isRestrictUser: params?.isRestrictUser ? params?.isRestrictUser : null, //isRestrictUser=1 时 匹配允许开单医生
    },
  }
}
export function getTreatmentServiceCompletions(
  params: {
    keyword: string
    current: number
    size?: number
  },
  insuranceCode?: string,
  isFullMatch?: any,
  isWubi?: any,
  phone?: string,
  isMember?: any, //是否会员开方
): Request {
  return {
    url: `${API_PREFIX}/blade-store/treatmentServiceCatalog/page`,
    method: 'GET',
    params: {
      billingCategory: -1,
      state: 1, //租户物资状态:0注销:1启用
      size: params.size || 5,
      current: params.current,
      name: params.keyword,
      insuranceCode,
      approveFlg: insuranceCode && insuranceCode != 'ZIFEI' ? null : 1,// 审批标志,写死查询审批已通过
      isFullMatch: isFullMatch?.toString() ? 0 : undefined,//是否完全匹配   
      isWubi: isWubi || '0',
      phone: phone ? phone : undefined,
      isMember: isMember, //是否会员开方
    },
  }
}


export function getMaterialCompletionSecond(
  params: { keyword: string; current: number; size?: number
},
  recipeCategory?: RecipeCategory,
  includeAllTcm?: boolean,
  insuranceCode?: string,
  isFullMatch?: any,
  isWubi?: any,
  isRestrictUser?: any,
  storehouseCategory?: any,
  normalGysName?:any,
  merge?: boolean,
  isAllInventory?: any,
  phone?: string
): Request {
  let flag = 0
  switch (recipeCategory) {
    case RecipeCategory.Dispose:
      flag = 5
      break
    case RecipeCategory.Medicine:
    case RecipeCategory.ShuZhuFang:
      flag = 1
      break
    case RecipeCategory.TcmGranules:
      flag = includeAllTcm ? 4 : 2
      break
    case RecipeCategory.TcmApply:
    case RecipeCategory.Tcm:
      flag = includeAllTcm ? 4 : 3
      break
  }

  return {
    url: `${API_PREFIX}/blade-store/materialscatalog/pageSecond`,
    method: 'GET',
    params: {
      //诊疗参数
      billingCategory: -1,
      name: params.keyword,
      //材料参数
      materialsCategory: -1, // materialscategory 供货物资类别:0药品:1材料:2器械:3保健品:4非药品
      allMaterials: -1, //allMaterials ==  0兴奋剂标记 1麻黄碱标识 2抗生素标识 3基药标记
      tenantSupplierId: -1, //供应商id
      state: 1,  //租户物资状态:0注销:1启用
      otc: -1,
      current: params.current,
      size: params.size || 5,
      flag:
        storehouseCategory == 2
          ? 4
          : storehouseCategory == 1
          ? 1
          : recipeCategory === undefined
          ? undefined
          : flag,
      insuranceCode,
      approveFlg: insuranceCode && insuranceCode != 'ZIFEI' ? null : 1,// 审批标志,写死查询审批已通过
      isFullMatch: isFullMatch?.toString() ? 0 : undefined,//是否完全匹配   
      isWubi: isWubi || '0',
      isRestrictUser: isRestrictUser ? isRestrictUser : null, //isRestrictUser=1 时 匹配允许开单医生
      normalGysName:normalGysName ? normalGysName :null, //常用供应商
      mergeFlag: merge ? 1 : 0,
      serviceShopPrice: isAllInventory ? null : 1,// 售药权限:0无权限:1有权限
      phone: phone ? phone : undefined,
    },
  }
}

export function getInventoryCompletionSecond(
  params: {
    keyword: string
    current: number
    size?: number
    storehouseId?: string
    merge?: boolean
    serviceShopPrice?: string
    isAllInventory?: boolean
    isFullMatch?: any
    deadlineFlag?: any
    isWubi?: any
    isRestrictUser?: any
    normalGysName?:any
    phone?: string
  },
  recipeCategory?: RecipeCategory,
  includeAllTcm?: boolean,
  insuranceCode?: string
): Request {
  let flag = 0
  switch (recipeCategory) {
    case RecipeCategory.Dispose:
      flag = 5
      break
    case RecipeCategory.Medicine:
    case RecipeCategory.ShuZhuFang:
      flag = 1
      break
    case RecipeCategory.TcmGranules:
      flag = includeAllTcm ? 4 : 2
      break
    case RecipeCategory.TcmApply:
    case RecipeCategory.Tcm:
      flag = includeAllTcm ? 4 : 3
      break
  }
  return {
    url: `${API_PREFIX}/blade-store/inventoryledger/pageSecond`,
    method: 'GET',
    params: {
      billingCategory: -1,
      name: params.keyword,
      current: params.current,
      size: params.size || 5,
      state: 1, //租户物资状态:0注销:1启用
      flag,
      storehouseId: params.storehouseId,
      mergeFlag: params.merge ? 1 : 0,
      serviceShopPrice: params.isAllInventory ? null : 1, // 售药权限:0无权限:1有权限
      insuranceCode,
      approveFlg: insuranceCode && insuranceCode != 'ZIFEI' ? null : 1, // 审批标志,写死查询审批已通过
      isFullMatch: params?.isFullMatch?.toString() ? 0 : undefined,//是否完全匹配   
      deadlineFlag: params?.deadlineFlag ? params?.deadlineFlag : undefined,
      isWubi: params?.isWubi || '0',
      isRestrictUser: params?.isRestrictUser ? params?.isRestrictUser : null, //isRestrictUser=1 时 匹配允许开单医生
      normalGysName: params?.normalGysName ? params?.normalGysName : null, //常用供应商
      phone: params?.phone ? params?.phone : undefined,
    },
  }
}
